var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDoctor = function SvgDoctor(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#doctor_svg__a)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15,
    height: 15,
    x: 2.5,
    y: 2.5,
    fill: "#66AF8C",
    rx: 2
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M14.167 8.442h-2.609V5.833H8.442v2.609H5.833v3.116h2.609v2.609h3.116v-2.609h2.608z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "doctor_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h20v20H0z"
  })))));
};
export default SvgDoctor;